import axios from 'axios';
import {
  LOGGER_LOAD_PREVIEW_LOGS_BEGIN,
  LOGGER_LOAD_PREVIEW_LOGS_SUCCESS,
  LOGGER_LOAD_PREVIEW_LOGS_FAILURE,
  LOGGER_LOAD_PREVIEW_LOGS_DISMISS_ERROR,
} from './constants';

const prepareEnvironmentUrl = (seoName, environment) => {
  let protocal = 'https';
  if (!process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'DEV') {
    protocal = 'http';
  }
  if (environment === 'ALPHA') {
    return `${protocal}://${seoName}.${process.env.REACT_APP_EXCHANGE_ENGINE_ALPHA}api/v1/logs/read-logs`;
  } else if (environment === 'BETA') {
    return `${protocal}://${seoName}.${process.env.REACT_APP_EXCHANGE_ENGINE_BETA}api/v1/logs/read-logs`;
  } else if (environment === 'PRODUCTION') {
    return `${protocal}://${seoName}.${process.env.REACT_APP_EXCHANGE_ENGINE}api/v1/logs/read-logs`;
  } else {
    return `${protocal}://${seoName}.${process.env.REACT_APP_EXCHANGE_ENGINE_PREVIEW}api/v1/logs/read-logs`;
  }
};

export function loadPreviewLogs(args = {}) {
  return (dispatch) => {
    dispatch({
      type: LOGGER_LOAD_PREVIEW_LOGS_BEGIN,
    });
    const { seoName, lines, searchTerm, projectId, environment } = args;
    let url = prepareEnvironmentUrl(seoName, environment);
    const body = { seoName: projectId, lines };
    if (searchTerm) {
      body.searchTerm = searchTerm;
    } else {
      body.searchTerm = '';
    }

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(url, body);
      doRequest.then(
        (res) => {
          dispatch({
            type: LOGGER_LOAD_PREVIEW_LOGS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: LOGGER_LOAD_PREVIEW_LOGS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPreviewLogsError() {
  return {
    type: LOGGER_LOAD_PREVIEW_LOGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGGER_LOAD_PREVIEW_LOGS_BEGIN:
      return {
        ...state,
        loadPreviewLogsPending: true,
        loadPreviewLogsError: null,
      };

    case LOGGER_LOAD_PREVIEW_LOGS_SUCCESS:
      return {
        ...state,
        loadPreviewLogsPending: false,
        loadPreviewLogsError: null,
        logs: action.data,
      };

    case LOGGER_LOAD_PREVIEW_LOGS_FAILURE:
      return {
        ...state,
        loadPreviewLogsPending: false,
        loadPreviewLogsError: action.data.error,
      };

    case LOGGER_LOAD_PREVIEW_LOGS_DISMISS_ERROR:
      return {
        ...state,
        loadPreviewLogsError: null,
      };

    default:
      return state;
  }
}
